// This code is copied over from VPC
import * as DOMPurify from 'dompurify';

export function sanitize(untrustedHtml: string): string {
  return DOMPurify.sanitize(untrustedHtml, {SAFE_FOR_TEMPLATES: true});
}

export type ISanitizer = typeof sanitize;
